import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import OrchestrateAndOptimizeImage from './OrchestrateAndOptimizeImage'

const copy = {
  overline: `Orchestrate and optimize quickly with AI co-pilot`,
  heading: `Save time writing, testing, and maintaining code with AI`,
  description1: `Generate complete Functions in minutes from natural language prompts - without the hassle of manual coding. Plus, optimize existing Functions with AI recommendations for improvement.`,
}

export const OrchestrateAndOptimize = () => {
  return (
    <Wrapper>
      <SectionComponent variant="2Col" copyVariant="narrow">
        <Section.Copy alignSelf="center">
          <CopyTextBase>
            <CopyText.Overline>{copy.overline}</CopyText.Overline>
            <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
            <CopyText.Description tag="h2">{copy.description1}</CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <OrchestrateAndOptimizeImage />
        </Section.Contents>
      </SectionComponent>
    </Wrapper>
  )
}

const SectionComponent = styled(SectionBase)`
  overflow-x: visible;
  justify-content: center;
  ${Section.Wrapper} {
    padding-top: 176px;
    padding-bottom: 80px;
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-top: 40px;
      padding-bottom: 40px;
    }
  }
`

const Wrapper = styled.div``

export default OrchestrateAndOptimize
